import Phaser from "phaser";
import { cDisplay } from "../cDisplay";
import { cButton } from "../cGameObjects/cButton";
import { cScene } from "../cScene";
import { ScreenItem, ScreenObject } from "../dataTypes";
import { net } from "../utils/net";
import { getStr } from "../utils/simpleLocalisation";
import { cText } from "../cGameObjects/cText";
import { cSprite } from "../cGameObjects/cSprite";



export class popupChoice extends Phaser.GameObjects.Container {

  private basePath: string 
  private sData:any;
  private choiceData: any
  private disp!: cDisplay
  private cb: Function

  private bubbles: cSprite[]

  constructor(sc:cScene, data:any, cb: Function){
    super(sc,0,0);
    this.cb = cb
    this.choiceData = data;    
    this.basePath = '/screens/99_popup_choice';
    this.bubbles = []
    net.fetchJson( this.basePath + '/screen.json',{},(data:ScreenObject)=>{  
      this.sData = data;
      this.loadAssets();
    });
  }

  loadAssets(){
    let onCompleted = ()=>{
      this.scene.load.off('complete',onCompleted);
      this.buildScreen();          
    }

    (this.scene as cScene).preload( this.sData.assets, net.serverUrl + '/screens/99_popup_choice/' )
    this.scene.load.on('complete',onCompleted);
    this.scene.load.start();        
  }


  buildScreen(){    
    this.disp = new cDisplay(this.scene,this.sData.screen, ()=>{
      //readys
    });
    this.add(this.disp)
    var count
    if (this.choiceData.value_c !== '' && this.choiceData.value_c !== undefined){
      count = 3
    }else{
      this.disp.getByName('btn_3').visible = false      
      this.disp.getByName('text_3').visible = false      
      this.disp.getByName('bubble_3').visible = false      
      count = 2
    }

    //var xx = (1920/2) - ((444*count)/2)
    var a;
    for (a=1; a < count+1;a++){
      var btn:cText = this.disp.getByName(`text_${a}`) as cText
      btn.textdata = getStr( this.choiceData[`value_${ ['','a','b','c'][a] }`] )
    }

    var maxHi = 0
    for (a=1; a < count+1;a++){
      var txt:cText = this.disp.getByName(`text_${a}`) as cText
      var bub:cSprite = this.disp.getByName(`bubble_${a}`) as cSprite
      var but:cButton = this.disp.getByName(`btn_${a}`) as cButton

      var hi = txt.calcTextHeight();
      var frame = '3.png'
      if (hi > 100 && hi < 300){
        frame = '2.png'
      }else if (hi > 300 ){
        frame = '1.png'
      }
      bub.setFrame(frame)
      bub.x = (-count * 430 / 2) + (a*430) - 215
      bub.originY = 0
      bub.originX = 0
      bub.y = 0

      txt.y = bub.y - (hi/2);
      txt.x = bub.x - (390/2);
      but.x = bub.x
      but.y = txt.y + hi + 85
      this.bubbles.push(bub);
      maxHi = Math.max(maxHi,hi)
    }

    var mx = Math.random() > 0.5 ? 1 : -1 
    this.disp.getByName('head').y = maxHi + 100
    this.disp.getByName('head').x += count===2 ? 0 : -200*mx
    this.disp.getByName('head').setScale( mx ,1)
    this.disp.getByName('head').setFrame(this.choiceData.question)

    //this.disp.getByName('txt_question').text = getStr( this.choiceData.question )

    this.disp.events.addListener('action',(action:string, el:any, data:ScreenItem)=>{
      var idx = ['btn_1','btn_2','btn_3'].indexOf(el.name)
      var char = ['a','b','c'][idx]
      this.disp.close(()=>{
        this.cb(char)
        this.destroy(true)
      })
    });


    const getR = ()=>Phaser.Math.Between(0, 360);

    var x1:any = [getR(),getR(),getR()]
    var y1:any = [getR(),getR(),getR()]
    this.scene.events.on('render',()=>{
      this.bubbles.forEach((e,i)=>{
        x1[i] = (x1[i] + 1) % 360
        y1[i] = (y1[i] + 1) % 360        
        var sx = Math.sin(x1[i] / 180 * Math.PI) * 0.031
        var sy = Math.cos(y1[i] / 180 * Math.PI) * 0.031
        e.setScale( 0.969+sx, 0.969+sy)
      })
    });
    this.anim('in')
  }


  anim(dir:string){


    var bg:cSprite = this.disp.getByName('bg') as cSprite
    bg.alpha = 0
    this.scene.tweens.add({
      duration: 1000,
      targets: [bg],
      alpha: 1,
      ease:Phaser.Math.Easing.Back.Out
    });




  }

}